export interface RefreshConfig {
  authApiUrl: string;
}

let inFlight: Promise<boolean> | null = null;

export async function refreshAuth(config: RefreshConfig): Promise<boolean> {
  // De-duplicate concurrent refresh calls. Multiple in-flight 401s would
  // otherwise hammer /auth/refresh; one shared promise is enough.
  if (inFlight) return inFlight;
  const base = config.authApiUrl.replace(/\/$/, "");
  inFlight = (async () => {
    try {
      const res = await fetch(`${base}/auth/refresh`, {
        method: "POST",
        credentials: "include",
        cache: "no-store",
      });
      return res.ok;
    } catch {
      return false;
    } finally {
      // Clear after a microtask so back-to-back callers within the same tick
      // still share, but later calls go through fresh.
      queueMicrotask(() => {
        inFlight = null;
      });
    }
  })();
  return inFlight;
}

export async function withRefreshOn401<T extends Response>(
  config: RefreshConfig,
  run: () => Promise<T>,
): Promise<T> {
  const first = await run();
  if (first.status !== 401) return first;
  const refreshed = await refreshAuth(config);
  if (!refreshed) return first;
  return run();
}
